import { formatQueueStatus, type MediaQueueInfo } from "@/shared/lib/queueInfo";
import { cn } from "@/shared/lib/utils";

/**
 * 排队提示(详情页正文用):只在 PENDING + queueInfo 且被本户上限卡住时渲染
 * 「本账号同时最多 N 条在做,前面的做完会自动开始」;其余情况不渲染任何东西。
 * 卡片上别用它(会撑高卡片)—— 卡片把 `formatQueueStatus().hint` 挂在 title 上。
 */
export function QueueHint({
  status,
  queueInfo,
  className,
}: {
  status: string | null | undefined;
  queueInfo: MediaQueueInfo | null | undefined;
  className?: string;
}) {
  const hint = formatQueueStatus(status, queueInfo)?.hint;
  if (!hint) return null;
  return (
    <p data-testid="queue-hint" className={cn("text-xs text-muted-foreground", className)}>
      {hint}
    </p>
  );
}
